import { render } from "./PedidoManualView.vue?vue&type=template&id=840171f8&scoped=true"
import script from "./PedidoManualView.vue?vue&type=script&lang=js"
export * from "./PedidoManualView.vue?vue&type=script&lang=js"

import "./PedidoManualView.vue?vue&type=style&index=0&id=840171f8&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD25\\Induscapas\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-840171f8"]])

export default __exports__